<template>
  <div>
    <el-card>
      <el-form
        :model="list"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-form-item label="商品名称" prop="floorName">
            <el-input
              placeholder="请输入内容"
              v-model="list.goodsName"
              clearable
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="原价" prop="price">
              <el-input
                placeholder="请输入内容"
                v-model="list.oldPrice"
                type="number"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="实际售价" prop="phone">
              <el-input
                placeholder="请输入内容"
                v-model="list.price"
                type="number"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="商品说明" prop="content">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="list.goodsDesc"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否推荐" prop="type">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="list.isRecommend"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="商品类别">
              <el-cascader
                v-model="cascader"
                :options="options"
                @change="handleChange"
                style="width: 300px"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="封面图（700*700）"
              prop="coverUrl"
              ref="coverUrl"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="list.coverUrl"
                  :src="list.coverUrl"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客服编号" prop="content">
              <!-- <el-input
                placeholder="请输入内容"
                v-model="list.customerNumber"
                clearable
              ></el-input> -->
                <el-select
                v-model="list.customerNumber"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["Changedata"],
  data() {
    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      list: [],
      type: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      options2:[
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
        {
          value: "6",
          label: "6",
        },
        {
          value: "7",
          label: "7",
        },
        {
          value: "8",
          label: "8",
        },
        {
          value: "9",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
      ],
      cascader: [],
      options: [],
      scTypeId: "",
      id: "",
    };
  },
  mounted() {
    this.list = this.Changedata;
    this.id = this.Changedata.scTypeId;
    console.log(this.Changedata, "Changedata");
    this.getList();
  },
  methods: {
    upSuccess(file) {
      this.list.coverUrl = file.entity;
    },
    handleChange(value) {
      this.scTypeId = value;
    },
    submitAdd() {
      var id;
      if(this.scTypeId){
        id = this.scTypeId.pop();
      }else{
        id=this.list.scTypeId
      }
      this.postAxios("/goods/spu/update", {
        id: this.list.id,
        coverUrl: this.list.coverUrl,
        goodsName: this.list.goodsName,
        price: this.list.price,
        oldPrice: this.list.oldPrice,
        scTypeId: id,
        isRecommend: this.list.isRecommend,
        goodsDesc: this.list.goodsDesc,
        customerNumber:this.list.customerNumber
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getList() {
      var three, second, first;
      this.getAxios("/scType/list").then((res) => {
        this.cascader = [];
        // 回显
        res.content.map((i, ind) => {
          // this.list.scTypeId
          i.childList.map((x) => {
            x.childList.map((n) => {
              if (n.id == this.id) {
                second = n.fatherId;
                this.cascader.unshift(n.id);
              }
            });
            if (x.id == second) {
              first = x.fatherId;
              this.cascader.unshift(x.id);
            }
          });
          if (i.id == first) {
            this.cascader.unshift(i.id);
          }
        });
        this.options=[];
        res.content.map((i, ind) => {
          this.options.push({
            label: i.typeName,
            value: i.id,
            children: [],
          });
          i.childList.map((x, y) => {
            if (x.childList.length == 0) {
              this.options[ind].children.push({
                label: x.typeName,
                value: x.id,
              });
            } else {
              this.options[ind].children.push({
                label: x.typeName,
                value: x.id,
                children: [],
              });
            }

            if (i.childList[y].childList != []) {
              i.childList[y].childList.map((n) => {
                this.options[ind].children[y].children.push({
                  label: n.typeName,
                  value: n.id,
                });
              });
            }
          });
        });
      });
    },
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
      this.id = newVal.scTypeId;
      this.getList();
    },
  },
};
</script>